import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBatchPaymentDownloadIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 9,
			y1: 4,
			x2: 9,
			y2: 13,
			stroke: "#0061E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 10L9 13L6 10",
			stroke: "#0061E8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9,
			cy: 9,
			r: 8.5,
			stroke: "#0061E8"
		})
	]
});
export default SvgBatchPaymentDownloadIcon;
